import { Kit, CREABOTS_KIT_ID_TYPE, BOARD_ID_TYPE } from '@sections/creabots/types/kits';
import { friendlyRobot } from './projects/friendlyRobot';
import { justDance } from './projects/justDance';
import { smartHome } from './projects/smartHome';
import { smartTrashCan } from './projects/smartTrashCan';
import { automaticFeeder } from './projects/automaticFeeder';

import * as routes from '@educabot/educablocks-cosmos';

const aiKit: Kit = {
  id: CREABOTS_KIT_ID_TYPE.AI,
  name: 'creabots.tutorials.ai.name',
  urlName: 'inteligencia-artificial',
  boardId: BOARD_ID_TYPE.AI,
  imageUrl: `${routes.bloquesUri}/images/creabots/ai/packaging.png`,
  projects: [friendlyRobot, justDance, automaticFeeder, smartHome, smartTrashCan],
};

export default aiKit;
